/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPasswordWithTokenCommand
 */
export interface SetPasswordWithTokenCommand {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordWithTokenCommand
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordWithTokenCommand
     */
    token: string;
}

export function SetPasswordWithTokenCommandFromJSON(json: any): SetPasswordWithTokenCommand {
    return SetPasswordWithTokenCommandFromJSONTyped(json, false);
}

export function SetPasswordWithTokenCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasswordWithTokenCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
        'token': json['token'],
    };
}

export function SetPasswordWithTokenCommandToJSON(value?: SetPasswordWithTokenCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'token': value.token,
    };
}

